<template>
  <el-dialog :visible.sync="showSetTable" top="7vh" title="自定义表头" custom-class="table-header-dia">
    <div class="check-wrap">
      <div class="check-item-left">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div class="check-wrap-left">
          <div class="table-head-box">
            <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="el in dataGroup" :label="el" :key="el.key" :disabled="el.disabled" value-key="key">{{
                el.label
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div>
        <div class="check-wrap-title">上下拖拽自定义顺序</div>
        <div class="check-wrap-right">
          <!-- 使用 vuedraggable 包裹 drag-item -->
          <draggable v-model="checkList" handle=".handle" filter=".forbid" :move="handleMove">
            <transition-group>
              <div
                :class="['drag-item', item.dragFlag ? 'handle' : 'forbid']"
                v-for="(item, index) in checkList"
                :key="index"
              >
                {{ item.label }}
              </div></transition-group
            >
          </draggable>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="showSetTable = false">取 消</el-button>
      <el-button type="primary" @click="saveSet">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import draggable from 'vuedraggable'; // 导入 vuedraggable
export default {
  data() {
    return {
      showSetTable: false,
      dataGroup: [],
      checkList: [],
      isIndeterminate: false,
      checkAll: false
    };
  },
  components: {
    draggable
  },
  props: {
    tableTitleType: {
      type: Number, //列表表头类型，2为货源列表
      default: 2 //列表表头类型，2为货源列表
    }
  },
  methods: {
    openDia() {
      axios.post(api.settingTableTitleQuery, { tableTitleType: this.tableTitleType }).then(res => {
        this.dataGroup = res.data.data;
        this.checkList = res.data.data.filter(el => el.choose == true);
        this.checkList = this.checkList.sort((a, b) => a.id - b.id);
        let checkListCount = this.checkList.length || 0;
        this.checkAll = checkListCount === this.dataGroup.length;
        this.isIndeterminate = checkListCount > 0 && checkListCount < this.dataGroup.length;
        this.showSetTable = true;
      });
    },
    async saveSet() {
      let tableTitleList = [];
      this.checkList.forEach(el => {
        tableTitleList.push({ label: el.label, prop: el.key });
      });
      await axios.post(api.settingTableTitleSave, {
        tableTitleType: this.tableTitleType,
        tableTitleList: tableTitleList
      });
      this.showSetTable = false;
      this.$emit('backTableHead');
    },
    handleCheckAllChange(val) {
      let checkData = this.checkList.filter(el => el.disabled == true && el.choose == true);
      this.checkList = val ? this.dataGroup : checkData;
      this.isIndeterminate = val ? false : true;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.dataGroup.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.dataGroup.length;
      //   操作保持最后
      let operationIdx = value.findIndex(el => el.key === 'operation');
      if (operationIdx != -1) {
        let operationData = this.checkList[operationIdx];
        this.checkList.splice(operationIdx, 1);
        this.checkList.push(operationData);
      }
    },

    handleMove(evt, originalEvent) {
      const targetIndex = evt.draggedContext.futureIndex;
      const targetItem = this.checkList[targetIndex];
      // 检查目标项是否是 不可拖拽的DOM元素
      if (targetItem && !targetItem.dragFlag) {
        // 如果拖动项要停靠在不可停靠的DOM元素之后，阻止拖动
        return false;
      }
    }
  }
};
</script>
<style lang="postcss">
.table-header-dia {
  width: 1120px;
  .table-check-all {
    margin: 10px 0 10px 60px;
  }
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    margin: 0 10px 0 32px;
    .el-checkbox {
      width: 190px;
      margin-bottom: 10px;
      margin-right: 42px;
    }
    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }
  }
  .check-wrap {
    display: flex;
    align-content: space-between;
    .check-item-left {
      width: 70%;
      margin-right: 32px;
    }
    .check-wrap-left {
      height: 400px;
      overflow: scroll;
      border-radius: 4px;
      border: 1px solid #e9e9e9;
      margin-top: 12px;
      padding: 12px 0;
      .el-checkbox__label {
        font-size: 14px;
        font-weight: 400;
        color: #aaa;
      }
      .is-checked {
        .el-checkbox__label {
          font-size: 14px;
          font-weight: 400;
          color: #333333 !important;
        }
      }
    }
    .check-wrap-right {
      height: 400px;
      overflow: scroll;
      display: flex;
    }
    .check-wrap-title {
      font-size: 14px;
      font-weight: 400;
      color: #aaaaaa;
      padding-left: 22px;
      background: url('../assets/img/ico16px_sxtz@2x.png') no-repeat;
      background-size: 16px 16px;
      background-position: left center;
      margin-bottom: 12px;
    }
    .drag-item {
      min-width: 120px;
      background: #fafcfe;
      border-radius: 4px;
      padding: 14px 40px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 6px;
    }
    .drag-item:hover {
      background: #f0f7ff;
    }
  }
}
</style>
